
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rewriting/informal-rewriting",
      function () {
        return require("private-next-pages/rewriting/informal-rewriting.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rewriting/informal-rewriting"])
      });
    }
  